import CookieClicker from './CookieClicker';

export default CookieClicker;
